import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("查看")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_header = _resolveComponent("page-header")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_bimgx_image = _resolveComponent("bimgx-image")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_page_header, {
      title: "表情包举报列表",
      "show-back": false
    }),
    _createVNode(_component_el_table, {
      data: _ctx.list,
      style: {"width":"100%","min-height":"500px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "hid",
          label: "举报Hid",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          label: "图片",
          width: "200"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_bimgx_image, {
              src: scope.row.img.url,
              style: {"width":"100px","height":"100px","object-fit":"contain"}
            }, null, 8, ["src"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "img.hid",
          label: "图片Hid",
          width: "180"
        }),
        _createVNode(_component_el_table_column, {
          prop: "user.nickname",
          label: "举报用户"
        }),
        _createVNode(_component_el_table_column, { label: "举报时间" }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", null, _toDisplayString(new Date(scope.row.createdAt).toLocaleString("zh-CN", { hour12: false })), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "状态" }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", null, _toDisplayString(scope.row.status == "AWAIT_REVIEW" ? "待审核" : (scope.row.status ==
                        "APPROVE" ? "已通过" : (scope.row.status == "DISAPPROVE" ? "不通过" : "未知状态"))), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "操作" }, {
          default: _withCtx((scope) => [
            _createVNode(_component_router_link, {
              to: '/censor/img-report-detail/' + scope.row.hid
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_el_pagination, {
      layout: "prev, pager, next",
      "current-page": _ctx.pagination.page,
      "onUpdate:current-page": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pagination.page) = $event)),
      "page-count": _ctx.pagination.pageCount
    }, null, 8, ["current-page", "page-count"])
  ]))
}